
import { useContext } from "react";
import AuthContext from "./Auth.context";
export const AuthHook = () => useContext(AuthContext)

